export const addResultsErgo = {
    namespaced: true,

    state: {
        attending: 1,
        health_statuses: [],
        results: {},
        initialResults: null,

        groupFilter: {
            selectedUserId: null,
            selectedSquadIds: [],
            showEverybody: true
        }
    },

    getters: {
        preparedResults(state) {
            if (!_.isEmpty(state.results) && state.results.sport) {
                let athlete_results = {};
                Vue.set(athlete_results, state.results.user_id, {});

                athlete_results[state.results.user_id].sports = [
                    {
                        id: state.results.id,
                        sport: state.results.sport.id
                    }
                ];

                athlete_results[state.results.user_id].sports[0].pieces = [];

                // look only for changes inside pieces form
                _.each(state.results.pieces.data, (piece, pieceIndex) => {
                    let pieceData = {};

                    if (piece.value !== state.initialResults.pieces.data[pieceIndex].value) {
                        pieceData.value = piece.value;
                    }

                    if (piece.split !== state.initialResults.pieces.data[pieceIndex].split) {
                        pieceData.average_split = piece.split;
                    }

                    if (piece.rate !== state.initialResults.pieces.data[pieceIndex].rate) {
                        pieceData.average_rate = piece.rate;
                    }

                    if (piece.average_power !== state.initialResults.pieces.data[pieceIndex].average_power) {
                        pieceData.average_power = piece.average_power;
                    }

                    if (piece.drive_length !== state.initialResults.pieces.data[pieceIndex].drive_length) {
                        pieceData.stroke_length = piece.drive_length;
                    }

                    if (piece.hr !== state.initialResults.pieces.data[pieceIndex].hr) {
                        pieceData.hr = piece.hr;
                    }

                    if (piece.lactates !== state.initialResults.pieces.data[pieceIndex].lactates) {
                        pieceData.lactates = piece.lactates;
                    }

                    if (piece.energy !== state.initialResults.pieces.data[pieceIndex].energy) {
                        pieceData.energy = piece.energy;
                    }

                    if (piece.average_peak_force !== state.initialResults.pieces.data[pieceIndex].average_peak_force) {
                        pieceData.average_peak_force = piece.average_peak_force;
                    }

                    if (
                        piece.peak_force_position !== state.initialResults.pieces.data[pieceIndex].peak_force_position
                    ) {
                        pieceData.peak_force_position = piece.peak_force_position;
                    }

                    if (piece.ergo_type.id !== state.initialResults.pieces.data[pieceIndex].ergo_type.id) {
                        pieceData.ergo_type = piece.ergo_type.id;
                    }

                    if (piece.segments) {
                        let segments = [];
                        // look only for changes inside piece segments form
                        _.each(piece.segments.data, (segment, segmentIndex) => {
                            let segmentData = {};

                            if (
                                segment.split !==
                                state.initialResults.pieces.data[pieceIndex].segments.data[segmentIndex].split
                            ) {
                                segmentData.split = segment.split;
                            }

                            if (
                                segment.rate !==
                                state.initialResults.pieces.data[pieceIndex].segments.data[segmentIndex].rate
                            ) {
                                segmentData.rate = segment.rate;
                            }

                            if (!_.isEmpty(segmentData)) {
                                segmentData.id = segment.id;
                                segments.push(segmentData);
                            }
                        });

                        if (!_.isEmpty(segments)) {
                            pieceData.segments = segments;
                        }
                    }

                    if (!_.isEmpty(pieceData)) {
                        pieceData.id = piece.id;
                        athlete_results[state.results.user_id].sports[0].pieces.push(pieceData);
                    }
                });

                // look only for changes inside overall form
                const overall = state.results.overall_results.data;
                const initialOverall = state.initialResults.overall_results.data;

                athlete_results[state.results.user_id].sports[0].overall = {};

                if (overall.total_distance !== initialOverall.total_distance) {
                    athlete_results[state.results.user_id].sports[0].overall.total_distance = overall.total_distance;
                }

                if (overall.total_time !== initialOverall.total_time) {
                    athlete_results[state.results.user_id].sports[0].overall.total_time = overall.total_time;
                }

                if (overall.split !== initialOverall.split) {
                    athlete_results[state.results.user_id].sports[0].overall.average_split = overall.split;
                }

                if (overall.rate !== initialOverall.rate) {
                    athlete_results[state.results.user_id].sports[0].overall.average_rate = overall.rate;
                }

                if (overall.average_power !== initialOverall.average_power) {
                    athlete_results[state.results.user_id].sports[0].overall.average_power = overall.average_power;
                }

                if (overall.drive_length !== initialOverall.drive_length) {
                    athlete_results[state.results.user_id].sports[0].overall.stroke_length = overall.drive_length;
                }

                return { athlete_results };
            }
        },

        preparedHealthStatuses(state) {
            const data = {};

            _.each(state.health_statuses, status => {
                data[status.id] = status.selected ? 1 : 0;
            });

            return data;
        }
    },

    mutations: {
        refreshErgoState(state) {
            Vue.set(state, 'attending', 1);
            Vue.set(state, 'health_statuses', []);
            Vue.set(state, 'results', {});
            Vue.set(state, 'groupFilter', {
                selectedUserId: null,
                selectedSquadIds: [],
                showEverybody: true
            });
        },

        setResults(state, data) {
            state.results = data.results;
            state.initialResults = _.cloneDeep(data.results);
            Vue.set(state.results, 'user_id', data.userId);
        }
    },

    actions: {
        addScores(context, payload) {
            return context.dispatch(
                'post',
                {
                    url: api + `session/${payload.id}/add-scores`,
                    data: payload.data
                },
                { root: true }
            );
        },

        setSessionAttendance(context, payload) {
            return context.dispatch(
                'post',
                {
                    url: api + 'session-attendance',
                    data: payload.data
                },
                { root: true }
            );
        }
    }
};
